"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelativeSignalSimplifiedSchema = exports.RelativeSignalSchema = exports.RelativeSignalNameTypeSimplifiedSchema = exports.RelativeSignalNameTypeSchema = exports.RelativeSignalSignalTypeSimplifiedSchema = exports.RelativeSignalSignalTypeSchema = void 0;
const zod_1 = require("zod");
const SignalId_1 = require("./DesignModels/SignalId");
exports.RelativeSignalSignalTypeSchema = zod_1.z.union([SignalId_1.SignalIdSchema, SignalId_1.SignalIdSchema.array()]);
exports.RelativeSignalSignalTypeSimplifiedSchema = zod_1.z.preprocess((val) => {
    if (Array.isArray(val)) {
        return val;
    }
    return [val];
}, SignalId_1.SimplifiedSignalIdSchema.array());
exports.RelativeSignalNameTypeSchema = zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())]);
exports.RelativeSignalNameTypeSimplifiedSchema = zod_1.z.preprocess((val) => {
    if (Array.isArray(val)) {
        return val;
    }
    return [val];
}, zod_1.z.array(zod_1.z.string()));
exports.RelativeSignalSchema = zod_1.z.object({
    signal: exports.RelativeSignalSignalTypeSchema.optional(),
    signal_name: exports.RelativeSignalNameTypeSchema.optional(),
});
exports.RelativeSignalSimplifiedSchema = zod_1.z.object({
    signal: exports.RelativeSignalSignalTypeSimplifiedSchema.optional(),
    signal_name: exports.RelativeSignalNameTypeSimplifiedSchema.optional(),
});
//# sourceMappingURL=RelativeSignal.js.map